import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router";

import { FlowBox } from "./../../../core/atoms/atoms";
import { PageImageHeader } from "./../../components/pageImageHeader";
import { officeHours } from "../customer/customerEnquiry/utils";
import * as WebRoutes from "@travellocal/utils/webRoutes";

export class Contact extends React.Component<{}, {}>{

  render() {
    return (
      <div className="contact-us">
        <Helmet
          title="Contact us"
          link={[
            {
              rel: "canonical",
              href: `${globalConfig.wwwBaseUrl}${WebRoutes.contactUs()}`,
            },
          ]}
        />
        <PageImageHeader imageSrc="/images/locations/05.jpg" imageMeta="Circular blue and gold floral pattern" title="Contact us" spaceForTabs={false}/>

        <div className="width-wrapper">
          <div className="sidebar">
            If you have a question about a specific destination then the best people to ask are our local travel company partners - nobody knows their countries better than they do. <Link to={WebRoutes.enquiryForm({ campaign: "contact" })}>Send an enquiry here</Link>.
        </div>

          <div className="main-content">
            <p>We'd love to hear from you! It can be about anything - help using the website, a question about our local experts or just a quick call to check we're real (yes, we get those!). The easiest and best way to contact us is to send us an email at the address below. We will get back to you as soon as we can - include your phone number if you'd like us to call you.</p>

            <p>Our Bristol office in the UK is open <strong>{officeHours}</strong>.</p>

            <FlowBox className="contact-info">
              <div>
                <h3>Office Address</h3>
                <p>
                  Runway East<br />
                  1 Victoria Street<br />
                  Bristol<br />
                  BS1 6AA<br />
                  UK
                </p>
              </div>

              <div>
                <h3>Phone Number</h3>
                <p>All enquiries: <strong><a href="tel:+441173257898">+44 (0)117 325 7898</a></strong></p>
              </div>

              <div>
                <h3>Email</h3>
                <p>General enquiries: <a href="mailto:team@travellocal.com?subject=An enquiry about TravelLocal">team@travellocal.com</a><br/>
                Press enquiries: <a href="mailto:pr@travellocal.com">pr@travellocal.com</a></p>
        </div>
            </FlowBox>
      </div>
        </div>
      </div>
    );
  }
}
